import React, { useState } from 'react';
import {
  BiCheckCircle,
  BiImage,
  BiPencil,
  BiSquare,
  BiTrash,
} from 'react-icons/bi';
import { CreatingImage } from './CreatingImage';
import { IoWarning } from 'react-icons/io5';
import { ImageZoom } from '../ImageZoom/image';

export const FixedChecklist = (props) => {
  const { checklistData, onChange, values } = props;

  const [isCreatingFixedTab, setIsCreatingFixedTab] = useState(false);
  const [editingFixedIndex, setEditingFixedIndex] = useState('');

  const handleDelete = (checklistName) => {
    delete values.entry_checklist.fixed_checklist[checklistName];

    onChange('entry_checklist', {
      image_register: values?.entry_checklist?.image_register,
      fixed_checklist: values.entry_checklist.fixed_checklist,
    });
  };

  function handleChangeStatus(checklistName) {
    const existingFixedChecklist =
      values.entry_checklist?.fixed_checklist || {};

    const currentStatus = existingFixedChecklist[checklistName]?.status || 1;
    const newStatus = currentStatus === 1 ? 2 : currentStatus === 2 ? 3 : 1;

    const fixedResult = {
      ...existingFixedChecklist,
      [checklistName]: {
        ...existingFixedChecklist[checklistName],
        status: newStatus,
      },
    };

    onChange('entry_checklist', {
      image_register: values.entry_checklist?.image_register,
      fixed_checklist: fixedResult,
    });
  }

  const haveItemValues = (itemValues) => {
    if (itemValues?.image) {
      return true;
    }
  };
  return (
    <div>
      {isCreatingFixedTab && (
        <CreatingImage
          isFixedChecklist
          setEditingIndex={setEditingFixedIndex}
          editingIndex={editingFixedIndex}
          values={values}
          onChange={onChange}
          setIsOpen={setIsCreatingFixedTab}
          isOpen={isCreatingFixedTab}
        />
      )}

      {checklistData?.length === 0 && (
        <span style={{ color: 'gray' }}>Nenhum checklist foi encontrado</span>
      )}

      <div className="os-entry-checklist-fixed-container">
        {checklistData?.map((item) => {
          const itemValues =
            values?.entry_checklist?.fixed_checklist?.[item?.name];

          const [isImageExpanded, setIsImageExpanded] = useState(false);

          return (
            <div
              style={{ border: '1px solid white', borderRadius: 6, padding: 4 }}
              key={item.id}
            >
              <div className="os-entry-checklist-fixed-container-item">
                <div
                  style={{ marginLeft: 2 }}
                  className="os-entry-checklist-fixed-container-item-title"
                >
                  {itemValues?.status === 1 || !itemValues?.status ? (
                    <BiSquare
                      onClick={() => handleChangeStatus(item?.name)}
                      size={20}
                    />
                  ) : itemValues?.status === 2 ? (
                    <BiCheckCircle
                      color="#52F035"
                      onClick={() => handleChangeStatus(item?.name)}
                      size={20}
                    />
                  ) : (
                    <IoWarning
                      color="#F24726"
                      onClick={() => handleChangeStatus(item?.name)}
                      size={20}
                    />
                  )}
                  <span className="os-entry-checklist-fixed-container-title">
                    {item?.name}
                  </span>
                </div>

                <div>
                  {haveItemValues(itemValues) ? (
                    <div>
                      <BiPencil
                        style={{ marginRight: 10 }}
                        onClick={() => {
                          setEditingFixedIndex(item?.name);
                          setIsCreatingFixedTab(true);
                        }}
                        className="os-entry-checklist-list-icon-style"
                      />

                      <BiTrash
                        onClick={() => handleDelete(item?.name)}
                        className="os-entry-checklist-list-icon-style"
                      />
                    </div>
                  ) : (
                    <BiImage
                      onClick={() => {
                        setIsCreatingFixedTab(true);
                        setEditingFixedIndex(item?.name);
                      }}
                      style={{ cursor: 'pointer' }}
                      color="#12CDD4"
                      size={28}
                    />
                  )}
                </div>
              </div>

              {haveItemValues(itemValues) && (
                <div style={{ display: 'flex', gap: 10 }}>
                  <div>
                    <ImageZoom
                      setIsImageExpanded={setIsImageExpanded}
                      image={itemValues?.image}
                      isImageExpanded={isImageExpanded}
                    />
                  </div>
                  <div
                    style={{ width: '100%' }}
                    className="os-entry-checklist-image-description"
                  >
                    <span className="os-entry-checklist-fixed-title">
                      <span style={{ color: 'gray', fontWeight: 'bold' }}>
                        Peça:{' '}
                      </span>
                      {itemValues?.piece?.label}
                    </span>

                    <span className="os-entry-checklist-fixed-title">
                      <span style={{ color: 'gray', fontWeight: 'bold' }}>
                        Descrição:{' '}
                      </span>
                      {itemValues?.description?.label}
                    </span>

                    <span className="os-entry-checklist-fixed-title">
                      <span style={{ color: 'gray', fontWeight: 'bold' }}>
                        Observações:{' '}
                      </span>
                      <span>{itemValues?.observation}</span>
                    </span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
